'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _size = require('lodash/size');

var _size2 = _interopRequireDefault(_size);

var _noop = require('lodash/noop');

var _noop2 = _interopRequireDefault(_noop);

var _constant = require('lodash/constant');

var _constant2 = _interopRequireDefault(_constant);

var _remove = require('lodash/remove');

var _remove2 = _interopRequireDefault(_remove);

var _trimStart = require('lodash/trimStart');

var _trimStart2 = _interopRequireDefault(_trimStart);

var _reactBootstrapTypeahead = require('react-bootstrap-typeahead');

var _FallbackImageLoader = require('@scoir/components-core/dist/components/FallbackImageLoader');

var _FallbackImageLoader2 = _interopRequireDefault(_FallbackImageLoader);

var _DismissableItem = require('../DismissableItem');

var _DismissableItem2 = _interopRequireDefault(_DismissableItem);

var _themes = require('../themes');

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DetailedTypeahead = function (_React$Component) {
    _inherits(DetailedTypeahead, _React$Component);

    function DetailedTypeahead() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, DetailedTypeahead);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DetailedTypeahead.__proto__ || Object.getPrototypeOf(DetailedTypeahead)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            options: [],
            error: false,
            page: 1
        }, _this._typeahead = _react2.default.createRef(), _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(DetailedTypeahead, [{
        key: 'renderCustomOption',
        value: function renderCustomOption(option, menuItemProps, idx) {
            var _props = this.props,
                labelKey = _props.labelKey,
                allowNewSelectionPrefix = _props.allowNewSelectionPrefix;

            return _react2.default.createElement(
                _reactBootstrapTypeahead.MenuItem,
                Object.assign({
                    key: idx,
                    className: 'detailed-typeahead-menu-item detailed-typeahead-custom-menu-item'
                }, menuItemProps),
                _react2.default.createElement(
                    'span',
                    null,
                    allowNewSelectionPrefix
                ),
                _react2.default.createElement(
                    'b',
                    null,
                    option[labelKey]
                )
            );
        }
    }, {
        key: 'renderPaginationOption',
        value: function renderPaginationOption(option, menuItemProps) {
            var labelKey = this.props.labelKey;

            return _react2.default.createElement(
                _reactBootstrapTypeahead.MenuItem,
                Object.assign({
                    key: 'detailed-typeahead-pagination-key',
                    className: 'detailed-typeahead-menu-item detailed-typeahead-pagination-menu-item'
                }, menuItemProps),
                _react2.default.createElement(
                    'span',
                    null,
                    option[labelKey]
                )
            );
        }
    }, {
        key: 'renderNotListedOption',
        value: function renderNotListedOption(option, menuItemProps, idx) {
            var labelKey = this.props.labelKey;

            return _react2.default.createElement(
                _reactBootstrapTypeahead.MenuItem,
                Object.assign({
                    key: idx,
                    className: 'detailed-typeahead-menu-item detailed-typeahead-not-listed-menu-item'
                }, menuItemProps),
                _react2.default.createElement(
                    'strong',
                    { className: 'detailed-typeahead-not-listed-option' },
                    option[labelKey]
                )
            );
        }
    }, {
        key: 'renderMenu',
        value: function renderMenu(results, menuProps) {
            var _this2 = this;

            var _props2 = this.props,
                allowNew = _props2.allowNew,
                notListedOption = _props2.notListedOption;

            return _react2.default.createElement(
                _reactBootstrapTypeahead.Menu,
                Object.assign({}, menuProps, {
                    text: 'detailed-typeahead',
                    className: (0, _classnames2.default)(menuProps.classname, 'ct-detailed-typeahead-menu') }),
                results.map(function (option, idx) {
                    var menuItemProps = {
                        disabled: option.disabled,
                        option: option,
                        position: idx
                    };
                    if (allowNew && (0, _get2.default)(option, 'customOption') === true) {
                        return _this2.renderCustomOption(option, menuItemProps, idx);
                    }
                    if ((0, _get2.default)(option, 'paginationOption')) {
                        return _this2.renderPaginationOption(option, menuItemProps);
                    }
                    if (!(0, _isUndefined2.default)(notListedOption) && idx === results.length - 1) {
                        return _this2.renderNotListedOption(option, menuItemProps, idx);
                    }
                    return _react2.default.createElement(
                        _reactBootstrapTypeahead.MenuItem,
                        Object.assign({ key: idx,
                            className: 'detailed-typeahead-menu-item'
                        }, menuItemProps),
                        _this2.renderMenuItemChildren(option)
                    );
                })
            );
        }
    }, {
        key: 'renderMenuItemChildren',
        value: function renderMenuItemChildren(result) {
            var _props3 = this.props,
                imgSrcFn = _props3.imgSrcFn,
                imgSrcFallbackFn = _props3.imgSrcFallbackFn,
                resultDisabledMessageFn = _props3.resultDisabledMessageFn,
                menuItemClassName = _props3.menuItemClassName,
                resultNameFn = _props3.resultNameFn,
                resultDescriptionFn = _props3.resultDescriptionFn;

            var imgSrc = imgSrcFn(result);
            var fallbackSrc = imgSrcFallbackFn(result);
            var disabledMessage = result.disabled ? resultDisabledMessageFn(result) : '';
            return _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)('detailed-result', menuItemClassName) },
                imgSrc && _react2.default.createElement(
                    'div',
                    { className: 'img-container' },
                    _react2.default.createElement(_FallbackImageLoader2.default, {
                        className: 'result-img',
                        src: imgSrc,
                        fallback: fallbackSrc
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'info' },
                    _react2.default.createElement(
                        'strong',
                        { className: 'name' },
                        resultNameFn(result)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'description' },
                        resultDescriptionFn(result)
                    ),
                    disabledMessage && _react2.default.createElement(
                        'div',
                        { className: 'disabled-message' },
                        disabledMessage
                    )
                )
            );
        }
    }, {
        key: 'search',
        value: function search(name) {
            var _this3 = this;

            var _props4 = this.props,
                allowNew = _props4.allowNew,
                labelKey = _props4.labelKey,
                onSearch = _props4.onSearch,
                notListedOption = _props4.notListedOption;

            var getOptions = function getOptions(response) {
                var customOption = _defineProperty({
                    customOption: true,
                    value: name
                }, labelKey, name);
                if (allowNew) {
                    return [customOption].concat(_toConsumableArray(response));
                }
                if (notListedOption) {
                    return [].concat(_toConsumableArray(response), [notListedOption]);
                }
                return [].concat(_toConsumableArray(response));
            };
            var trimmedName = (0, _trimStart2.default)(name);
            if (trimmedName.length > 0) {
                onSearch(trimmedName).then(function () {
                    var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

                    var options = getOptions(response);
                    _this3.setState({ options: options });
                }).catch(function () {
                    _this3.setState({ error: true });
                });
            }
        }
    }, {
        key: 'paginate',
        value: function paginate() {
            var _this4 = this;

            var page = this.state.page + 1;
            this.setState({ page: page });
            this.props.onPaginate(this.state.lastQuery, page).then(function (response) {
                _this4.setState(function (state) {
                    return Object.assign({}, state, {
                        options: [].concat(_toConsumableArray(state.options), _toConsumableArray(response))
                    });
                });
            });
        }
    }, {
        key: 'clear',
        value: function clear() {
            this._typeahead.current.getInstance().clear();
        }
    }, {
        key: 'inputChange',
        value: function inputChange(query) {
            this.setState({ lastQuery: query, page: 1 });
            this.props.onInputChange(query);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            var _state = this.state,
                error = _state.error,
                options = _state.options;

            var _props5 = this.props,
                filterByFn = _props5.filterByFn,
                clearOnSelect = _props5.clearOnSelect,
                _onChange = _props5.onChange,
                theme = _props5.theme,
                emptyLabel = _props5.emptyLabel,
                rest = _objectWithoutProperties(_props5, ['filterByFn', 'clearOnSelect', 'onChange', 'theme', 'emptyLabel']);

            var themeClass = _themes.themeDefinitions[theme].componentClass;

            return _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)('ct-detailed-typeahead-comp', themeClass) },
                _react2.default.createElement(_reactBootstrapTypeahead.AsyncTypeahead, Object.assign({}, rest, {
                    minLength: 1,
                    allowNew: false,
                    error: error,
                    options: options,
                    useCache: false,
                    multiple: false,
                    isLoading: false,
                    paginate: !!this.props.onPaginate,
                    onPaginate: function onPaginate() {
                        return _this5.paginate();
                    },
                    onInputChange: function onInputChange(query) {
                        return _this5.inputChange(query);
                    },
                    selectHintOnEnter: false,
                    ref: this._typeahead,
                    onSearch: function onSearch(search) {
                        return _this5.search(search);
                    },
                    renderMenu: function renderMenu(results, menuProps) {
                        if ((0, _size2.default)(results) > 0 || emptyLabel) {
                            return !(0, _isUndefined2.default)(_this5.props.renderCustomMenu) ? _this5.props.renderCustomMenu(menuProps, results) : _this5.renderMenu(results, Object.assign({}, menuProps, { emptyLabel: emptyLabel }));
                        }
                        return null;
                    },
                    filterBy: filterByFn,
                    onChange: function onChange(selection) {
                        var disabledSelection = (0, _remove2.default)(selection, function (result) {
                            return result.disabled;
                        });
                        if ((0, _size2.default)(selection) > 0) {
                            if (clearOnSelect) {
                                _this5.clear();
                            }
                            _onChange(selection);
                        } else if ((0, _size2.default)(disabledSelection) > 0) {
                            _this5.clear();
                        }
                    }
                }))
            );
        }
    }]);

    return DetailedTypeahead;
}(_react2.default.Component);

DetailedTypeahead.propTypes = {
    notListedOption: _propTypes2.default.object,
    align: _propTypes2.default.oneOf(['left', 'justify', 'right']),
    emptyLabel: _propTypes2.default.string,
    imgSrcFn: _propTypes2.default.func,
    imgSrcFallbackFn: _propTypes2.default.func,
    onInputChange: _propTypes2.default.func,
    resultNameFn: _propTypes2.default.func,
    resultDescriptionFn: _propTypes2.default.func,
    resultDisabledMessageFn: _propTypes2.default.func,
    filterByFn: _propTypes2.default.func,
    allowNew: _propTypes2.default.bool,
    allowNewSelectionPrefix: _propTypes2.default.string,
    clearOnSelect: _propTypes2.default.bool,
    placeholder: _propTypes2.default.string,
    labelKey: _propTypes2.default.string,
    bsSize: _propTypes2.default.oneOf(['sm', 'lg']),
    onChange: _propTypes2.default.func.isRequired,
    onSearch: _propTypes2.default.func.isRequired,
    onPaginate: _propTypes2.default.func,
    menuItemClassName: _propTypes2.default.string,
    maxResults: _propTypes2.default.number,
    theme: _propTypes2.default.oneOf(Object.values(_themes.themes)),
    id: _propTypes2.default.string.isRequired,
    renderCustomMenu: _propTypes2.default.func
};
DetailedTypeahead.defaultProps = {
    imgSrcFn: _noop2.default,
    imgSrcFallbackFn: _noop2.default,
    resultNameFn: function resultNameFn(result) {
        return result.name;
    },
    resultDescriptionFn: function resultDescriptionFn(result) {
        return result.value;
    },
    resultDisabledMessageFn: _noop2.default,
    placeholder: 'Search by name',
    clearOnSelect: false,
    labelKey: 'name',
    filterByFn: (0, _constant2.default)(true),
    allowNew: false,
    theme: _themes.themes.base,
    onInputChange: _noop2.default,
    id: 'ct-detailed-typeahead',
    emptyLabel: 'No matches found.'
};


DetailedTypeahead.themes = _themes.themes;
DetailedTypeahead.DismissableItem = _DismissableItem2.default;

exports.default = DetailedTypeahead;
//# sourceMappingURL=index.js.map